var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 460.775 460.775",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.7508 230.3949 405.3095 97.8447c4.7063-4.707 4.7063-12.3242 0-17.0297l-25.334-25.3433a12.045 12.045 0 0 0-8.514-3.5243 12.0454 12.0454 0 0 0-8.5149 3.5243L230.3879 188.032 97.8292 55.4717a12.0454 12.0454 0 0 0-8.5148-3.5243 12.0437 12.0437 0 0 0-8.5141 3.5243L55.4663 80.815c-4.707 4.7055-4.707 12.3226 0 17.0297l132.5587 132.551L55.4795 362.9302c-4.7047 4.707-4.7047 12.3242 0 17.0297l25.3355 25.3433c2.2548 2.2547 5.3174 3.5243 8.514 3.5243a12.0486 12.0486 0 0 0 8.5157-3.5243l132.5424-132.5448 132.5432 132.5448a12.0454 12.0454 0 0 0 8.5149 3.5243c3.1974 0 6.2593-1.2696 8.514-3.5243l25.3356-25.3433c4.7047-4.7055 4.7047-12.3226 0-17.0297z",
    id: "path2",
    strokeWidth: 0.7746
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.a9c0d98317c8be813aac46e7da1cec52.svg";
export { ForwardRef as ReactComponent };